import React, { Component } from "react";
import { connect } from "react-redux";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import { getUsuario } from "../usuario/UsuarioService";
import { idEmpresa } from "../../constans/constants";
import {
  registrarGrupo,
  editarGrupo,
} from "../usuario/UsuarioService";
import { validateForm } from "../../constans/validationUtils";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import BusquedaUsuario from "../componentes/BusquedaUsuario";
import ComponenteVacio from "../../components/componentes/avisos/ComponenteVacio";
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
  integrarConHandleInput
} from '../../constans/form-error-utils';

class GrupoUsuario extends React.Component {
  constructor(props) {
    super(props);

    const { tipoAccion } = props.match.params;

    const originalHandleInput = this.handleInput;
    this.handleInput = integrarConHandleInput(this, originalHandleInput);

    this.state = {
      descripcion: "",
      activo: true,
      id: "",
      usuarios: [],
      usuariosAux: [],
      openPantallaCarga: false,
      validated: false,
      pageSize: 5,
      search: "",
      usuariosSeleccionados: [],
      tipoAccion,
      titulo: null,
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      mensajeFlashSeverity: 'neutral',
      errors: []
    };
    this.tableRef = React.createRef();
  }

  reglasValidacionCampos = {
    descripcion: [
      { required: true, message: 'Campo obligatorio' },
      {
        customValidator: (value, formData) => {
          return value.length < 251
        }, message: 'La cantidad maxima de caracteres es de 50'
      }
    ]
  }

  validarCamposFormulario = () => {
    let { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    return { isValid, errors }
  }


  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  handleGrupoUsuarioSubmit = (event) => {
    event.preventDefault();
    const { isValid, errors } = this.validarCamposFormulario();
    if (isValid) {
      if (this.state.usuariosSeleccionados.length == 0) {
        this.setState({
          mensajeFlash: "Debe asignar al menos un usuario al grupo",
          mostrarMensajeFlash: true,
          mensajeFlashSeverity: "error"
        });
        return;
      }
      mostrarErroresEnFormulario({});
      this.setState({ openPantallaCarga: true });
      if (this.state.tipoAccion === "edit") {
        const json = {
          descripcion: this.state.descripcion,
          activo: this.state.activo,
          id: this.state.id,
          usuarios: this.state.usuariosSeleccionados,
          idEmpresa: idEmpresa(),
        };
        this.props.editarGrupo(json).then((response) => {
          this.props.history.push({
            pathname: '/administracion/grupos',
            state: {
              mostrarMensajeFlash: true,
              mensajeFlash: response.mensaje,
              mensajeFlashSeverity: response.error ? 'error' : 'exito'
            }
          })
        });
      } else if (this.state.tipoAccion === "add") {
        const json = {
          descripcion: this.state.descripcion,
          activo: this.state.activo,
          usuarios: this.state.usuariosSeleccionados,
          idEmpresa: idEmpresa(),
        };
        this.props.registrarGrupo(json).then((response) => {
          this.props.history.push({
            pathname: '/administracion/grupos',
            state: {
              mostrarMensajeFlash: true,
              mensajeFlash: response.mensaje,
              mensajeFlashSeverity: response.error ? 'error' : 'exito'
            }
          })
        });
      }
    } else {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
    }
  };


  componentDidMount() {
    configurarLimpiezaAutomatica()
    if (this.state.tipoAccion === "edit") {
      const { datosGrupo } = this.props.location.state;
      this.setState({
        descripcion: datosGrupo.descripcion,
        activo: datosGrupo.activo,
        id: datosGrupo.id,
        usuariosSeleccionados: datosGrupo.miembros,
        titulo: "Datos del grupo: " + datosGrupo.descripcion
      });
    }
  }

  handleInput = (e) => {
    let name = e.target.name;
    let val = e.target.value;
    this.setState({
      [name]: val,
    });
  };


  fetchUsuarios = (page, pageSize, search) => {
    return this.props.getUsuario(page, pageSize, search).then(() => {
      const { usuariosData } = this.props;
      return {
        items: usuariosData.usuarios,
        totalCount: usuariosData.totalCount,
      };
    });
  }

  handleUsuariosChange = (datos) => {
    this.setState({ usuariosSeleccionados: datos });
  };


  handleEliminarUsuario = (cedula) => {
    this.setState(
      (prev) => ({
        usuariosSeleccionados: prev.usuariosSeleccionados.filter(
          (u) => u.cedula !== cedula
        )
      })
    );
  };

  renderTablaUsuarios = () => {
    return (
      <div className="component-table">
        <h4 className="table-title"> Miembros del grupo </h4>
        <div className="responsive-table">
          <table>
            <thead>
              <tr>
                <th>Nombre completo</th>
                <th>Cédula de identidad</th>
                <th>Usuario</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {this.state.usuariosSeleccionados.map((elemento) => {
                return (<tr key={elemento.cedula}>
                  <td>{elemento.nombreApellido}</td>
                  <td>{elemento.cedula}</td>
                  <td>{elemento.usuario}</td>
                  <td>
                    <div className="table-actions">
                      <button onClick={() => this.handleEliminarUsuario(elemento.cedula)} className="table-icon open-dialog">
                        <span className="material-symbols-outlined"> delete </span>
                      </button>
                    </div>
                  </td>
                </tr>)
              })}
            </tbody>
          </table>
        </div>
      </div>

    );
  }


  render() {
    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl={'/administracion/grupos'}
                breadcrumbs={
                  [
                    { label: 'Grupos de usuarios', path: '/administracion/grupos' },
                    { label: this.props.match.params.tipoAccion !== 'edit' ? 'Nuevo grupo de usuarios' : 'Editar grupo', path: '' }
                  ]
                }
              />

              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title"> {this.state.titulo ?? "Registrar nuevo grupo"} </h1>
                  <p className="page-description"> Complete el siguiente formulario con los datos correspondientes </p>
                </div>
                <div className="head-actions">
                  <button onClick={this.handleGrupoUsuarioSubmit} className="btn-medium btn-primary"> Guardar cambios </button>
                </div>
              </div>

            </div>
          </header>
          <div className="wrapperContent">
            <div className="page-container">
              <div className="form">
                <div className="form-group__inline w-50 mt-0">
                  <div className="form-group">
                    <input type="text" id="descripcion" name="descripcion" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.descripcion} />
                    <label htmlFor="descripcion" className="form-label"> Descripción </label>
                  </div>
                  <BusquedaUsuario
                    selectedUsers={this.state.usuariosSeleccionados}
                    onSelectedUsersChange={this.handleUsuariosChange}
                  />
                  <div className="form-group">
                    <input type="checkbox" className="form-check" name="activo" id="activo" checked={this.state.activo} onChange={this.handleChange} />
                    <label htmlFor="activo" className="check-label"> Grupo activo </label>
                  </div>
                </div>
              </div>
              {this.state.usuariosSeleccionados.length == 0
                ? <ComponenteVacio />
                : this.renderTablaUsuarios()
              }
            </div>
          </div>
        </div>
        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity} />
        <PantallaCarga open={this.state.openPantallaCarga}/>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  registrarGrupo: (value) => dispatch(registrarGrupo(value)),
  editarGrupo: (value) => dispatch(editarGrupo(value)),
  getUsuario: (page, size, search) => dispatch(getUsuario(page, size, search)),
});

const mapStateToProps = (state) => ({
  usuariosData: state.usuariosData,
});

export default connect(mapStateToProps, mapDispatchToProps)(GrupoUsuario);
